import gql from "graphql-tag";

export default gql`
  query GetCompanyParts($id: ID!) {
    allParts(filter: { company: { id: $id } }) {
      id
      name
      description
      category
      unitCost
      quantity
      barcode
      additionalPartDetails
      site {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyParts.ts